import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
export const DiagnosisPanelAlertStore = FloatingAlertStore.newFloatingAlertStore();